<template>
    <el-collapse v-model="indicesCollapseListaDocumentos">
        <el-collapse-item :name="'collapse-lista-documentos'">
            <template #title>
                <span class="titulo">{{
                    $t('certification.messages.related_documents')
                }}</span>
            </template>
            <div class="titulo subtitle">
                {{ $t('certification.messages.document_list') }}
            </div>
            <div class="collapse-item">
                <el-table
                    id="tabelas-collapse"
                    :data="documentos"
                    style="width: 100%"
                >
                    <el-table-column align="left" label="teste">
                        <template #header="{ scope }">
                            <span class="titulo">{{
                                $t('certification.words.name')
                            }}</span>
                        </template>
                        <template v-slot:default="props">
                            <span>{{ props.row.nome }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center">
                        <template #header="{ scope }">
                            <span class="titulo">{{
                                $t('certification.words.registration_date')
                            }}</span>
                        </template>
                        <template v-slot:default="props">
                            <span>{{ props.row.data }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="right">
                        <template #header="{ scope }">
                            <span class="titulo acoes">{{
                                $t('certification.words.actions')
                            }}</span>
                        </template>
                        <template v-slot:default="props">
                            <span class="titulo">
                                <i
                                    class="mdi mdi-eye-outline"
                                    @click="baixarDoc(props.row)"
                                ></i>
                                <i
                                    v-if="!getAnyCertificado && canUploadFile"
                                    class="mdi mdi-trash-can-outline"
                                    @click="excluirDOc(props.row.id)"
                                ></i>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-upload
                v-if="canUploadFile && !getAnyCertificado"
                class="upload-btn"
                action="#"
                drag
                :file-list="fileList"
                :limit="1"
                :auto-upload="false"
                accept=".XLSX, .xlsx, .DOC, .doc, .DOCX, .docx, .pdf, .PDF, .xls, .XLS"
                :on-change="onLoadFile"
                ref="upload"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text w-100">
                    {{ $t('certification.messages.supported_files') }}
                    <em>{{ $t('certification.messages.click_to_upload') }}</em>
                </div>
            </el-upload>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
import formatter from '@/utils/formatters';
import Axios from 'axios';
import UtilsService from '@/services/UtilsService';
import { mapGetters } from 'vuex';

export default {
    name: 'CollapseListaDocumentos',
    props: {
        dados: {
            type: Object,
            required: true
        },
        dadosCertificacao: {
            type: Object,
            required: true
        },
        dadosTerritorio: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            indicesCollapseListaDocumentos: [{}],
            documentos: [],
            fileList: [],
            canUploadFile: true
        };
    },
    computed: {
        ...mapGetters(['getAnyCertificado'])
    },

    mounted() {
        this.validaSeExisteCertificacao();
        this.loadDocuments();
    },

    methods: {
        formatNumber(number, decimalPlaces = 2) {
            if (!number) return '-';
            return formatter.formatNumber(number, decimalPlaces) + ' ha';
        },
        async excluirDOc(id) {
            this.$messageBox
                .confirm(
                    this.$t(
                        'certification.messages.are_you_sure_you_want_to_remove_record'
                    ),
                    this.$t('certification.words.warning'),
                    {
                        confirmButtonText: this.$t('certification.words.delete'),
                        cancelButtonText: this.$t('certification.words.back'),
                        type: 'warning'
                    }
                )
                .then(() => {
                    this.handleDelete(id);
                });
        },
        async handleDelete(id) {
            let url =
                process.env.VUE_APP_HTTP_PATH +
                '/arquivoCertificacaoTerritorio/delete/' +
                id;
            const { data, status } = await Axios.delete(url);

            if (status === 200) {
                this.documentos = this.documentos.filter(doc => doc.id !== id);
                this.$notify.success({
                    message: this.$t('certification.messages.file_deleted_successfully')
                });
            } else {
                this.$notify.error({
                    message: data
                });
            }
        },
        async baixarDoc(doc) {
            let url = 'arquivoCertificacaoTerritorio/download/' + doc.id;

            try {
                UtilsService.baixarArquivo(url);

                this.$notify.success({
                    message: this.$t('certification.messages.file_download_will_start_soon')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('certification.messages.error_downloading_file')
                });
            }
        },

        validFileSize(file) {
            return file.size / 1024 / 1024 < 10;
        },

        async handleUpload(file) {
            const id = this.dadosCertificacao.id;

            let url =
                process.env.VUE_APP_HTTP_PATH +
                '/arquivoCertificacaoTerritorio/upload';
            let formData = new FormData();
            formData.append('file', file.raw);
            formData.append('certificacaoTerritorioGeometriaRelId', id);

            const { data, status } = await Axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (status === 200) {
                this.documentos.push({
                    id: data,
                    nome: file.name,
                    data: `${new Date().getDate()}/${
                        new Date().getMonth() + 1
                    }/${new Date().getFullYear()}`
                });
                this.$refs.upload.clearFiles();

                this.$notify.success({
                    message: this.$t('certification.messages.sucesso_upload')
                });
            } else {
                this.$notify.error({
                    message: this.$t('certification.messages.erro_upload')
                });
            }
        },

        async onLoadFile(file) {
            this.arquivo = file;
            if (this.validFileSize(file)) {
                this.handleUpload(file);
            } else {
                this.$notify.error({
                    title: this.$t('certification.words.error'),
                    message: this.$t('certification.messages.file_max_size')
                });
                this.$refs.upload.clearFiles();
            }
        },

        validaSeExisteCertificacao() {
            const listaCertificacao =
                this.dadosCertificacao['certificacaoTerritorioResultado'];

            listaCertificacao.forEach(certificacao => {
                if (certificacao.resultadoCodigo === 'CERTIFICADO') {
                    this.canUploadFile = false;
                }
            });
        },

        loadDocuments() {
            this.dadosTerritorio.consolidadoTerritorio.arquivosCertificacaoTerritorio.forEach(
                doc => {
                    this.documentos.push({
                        id: doc.id,
                        nome: doc.nome,
                        data: `${doc.dataUpload.dayOfMonth}/${doc.dataUpload.monthValue}/${doc.dataUpload.year}`
                    });
                }
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.titulo {
    font-weight: bold;

    i {
        font-size: 20px;
        cursor: pointer;
        margin-left: 5px;
    }
}

.subtitle {
    border-top: 1px solid var(--gray);
    padding-top: 5px;
}

.acoes {
    text-align: right;
}

.upload-btn {
    margin: 10px 0;
}
</style>
